var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditorItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01511 19V16.5H9.01511L12.0151 7.5H8.01511V5H18.0151V7.5H14.5151L11.5151 16.5H15.0151V19H5.01511Z",
    fill: "#343F40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorItalic);
export default __webpack_public_path__ + "static/media/editor-italic.95e02f94924d70fb3d33f026facf1c4e.svg";
export { ForwardRef as ReactComponent };